import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { vendorService } from "../../Services";
import { PhoneCode } from "../../Components";
import csc from "country-state-city";
import helperFunction from "../../Function/helperFunction";

const vendorTypeList = [
  { value: "Freight", label: "Freight" },
  { value: "Air", label: "Air" },
  { value: "Sea", label: "Sea" },
  { value: "Land", label: "Land" },
  { value: "Courier", label: "Courier" },
  { value: "Packing", label: "Packing" },
  { value: "Insurance", label: "Insurance" },
  { value: "Storage", label: "Storage" },
  { value: "Transport", label: "Transport" },
  { value: "Overseas", label: "Overseas" },
  { value: "Other", label: "Other" },
];

const serviceTypeList = [
  { value: "ONLINE", label: "Online" },
  { value: "OFFLINE", label: "Offline" },
];

export const EditVendor = () => {
  const history = useHistory();
  const data = history.location.state;
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [loader, setLoader] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [country] = useState(csc.getAllCountries());
  const [vendorTypeValue, setVendorTypeValue] = useState(
    vendorTypeList.filter((item) => item.value === data.vendor_type)[0]
  );
  const [serviceTypeValue, setServiceTypeValue] = useState(
    serviceTypeList.filter((item) => item.value === data.service_type)[0]
  );

  const onSelectVendorType = (e) => {
    setVendorTypeValue(e);
    formik.setValues({
      ...formik.values,
      vendor_type: e.value,
    });
  };

  const onSelectServiceType = (e) => {
    setServiceTypeValue(e);
    formik.setValues({
      ...formik.values,
      service_type: e.value,
    });
  };

  const onCountryChange = (e, name) => {
    if (name === "country") {
      setFieldValue("state", "");
      setFieldValue("city", "");
      setCities([]);
      setStates(csc.getStatesOfCountry(e.isoCode));
      setCountryCode(e.isoCode);
    } else if (name === "state") {
      setFieldValue("city", "");
      setCities(csc.getCitiesOfState(countryCode, e.isoCode));
    }
    setFieldValue(name, e.value);
  };

  const formik = useFormik({
    initialValues: {
      vendor_name: data.vendor_name,
      business_name: data.business_name,
      address: data.address ? data.address : "",
      vat_no: data.vat_no ? data.vat_no : "",
      vendor_email: data.vendor_email,
      vendor_contact_number: data.vendor_contact_number,
      vendor_type: data.vendor_type,
      service_type: data.service_type,
      id: data._id,
      country: data?.country || "",
      state: data?.state || "",
      city: data?.city || "",
      postal_code: data?.postal_code || "",
    },
    validationSchema: Yup.object({
      vendor_name: Yup.string().required("Required"),
      business_name: Yup.string().required("Required"),
      address: Yup.string().required("Required"),
      vat_no: Yup.string().required("Required"),
      vendor_type: Yup.string().required("Required"),
      service_type: Yup.string().required("Required"),
      vendor_email: Yup.string()
        .required("Required")
        .email("Please enter valid email"),
      vendor_contact_number: Yup.number()
        .min(10, "Too short")
        .typeError("Must be a number")
        .required("Required"),
      country: Yup.string().required("Required"),
      state: Yup.string().required("Required"),
      city: Yup.string().required("Required"),
      postal_code: Yup.string().required("Required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      let postData = {
        ...values,
        vendor_email: values.vendor_email.toLowerCase(),
      };
      vendorService.updateVendor(postData).then((res) => {
        if (res.status) {
          setLoader(false);
          history.goBack();
        } else {
          setLoader(false);
          toast.error(res.message);
        }
      });
    },
  });

  const { setFieldValue, errors, touched, getFieldProps } = formik;

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <form className="control-form">
              <div className="row">
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Vendor Type</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.vendor_type
                            ? !formik.errors.vendor_type
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={vendorTypeValue}
                      onChange={(e) => onSelectVendorType(e)}
                      options={vendorTypeList}
                    />
                    {formik.touched.vendor_type && formik.errors.vendor_type ? (
                      <div className="text-danger">
                        {formik.errors.vendor_type}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Service Type</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: formik.touched.service_type
                            ? !formik.errors.service_type
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                          boxShadow: "0 0 0 0px #f46a6a",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={serviceTypeValue}
                      onChange={(e) => onSelectServiceType(e)}
                      options={serviceTypeList}
                    />
                    {formik.touched.service_type &&
                    formik.errors.service_type ? (
                      <div className="text-danger">
                        {formik.errors.service_type}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Vendor Name</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.vendor_name
                          ? !formik.errors.vendor_name
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("vendor_name")}
                      placeholder="Enter Vendor Name"
                    />
                    {formik.touched.vendor_name && formik.errors.vendor_name ? (
                      <div className="text-danger">
                        {formik.errors.vendor_name}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Business Name</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.business_name
                          ? !formik.errors.business_name
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("business_name")}
                      placeholder="Enter Business Name"
                      minLength="10"
                    />
                    {formik.touched.business_name &&
                    formik.errors.business_name ? (
                      <div className="text-danger">
                        {formik.errors.business_name}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Address</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.address
                          ? !formik.errors.address
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("address")}
                      placeholder="Enter Address"
                    />
                    {formik.touched.address && formik.errors.address ? (
                      <div className="text-danger">{formik.errors.address}</div>
                    ) : null}
                  </div>
                </div>
                {/* Country */}
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Country</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: touched.country
                            ? !errors.country
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={
                        formik.values.country
                          ? {
                              label: formik.values.country,
                              value: formik.values.country,
                            }
                          : null
                      }
                      onChange={(e) => onCountryChange(e, "country")}
                      options={helperFunction.convertToSelectList(
                        country,
                        "name",
                        "name"
                      )}
                    />
                    {touched.country && errors.country && (
                      <div className="text-danger">{errors.country}</div>
                    )}
                  </div>
                </div>
                {/* State */}
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">State</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: touched.state
                            ? !errors.state
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={
                        formik.values.state
                          ? {
                              label: formik.values.state,
                              value: formik.values.state,
                            }
                          : null
                      }
                      onChange={(e) => onCountryChange(e, "state")}
                      options={helperFunction.convertToSelectList(
                        states,
                        "name",
                        "name"
                      )}
                    />
                    {touched.state && errors.state && (
                      <div className="text-danger">{errors.state}</div>
                    )}
                  </div>
                </div>
                {/* City */}
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">City</label>
                  </div>
                  <div className="col-9">
                    <Select
                      styles={{
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "calc(2.15rem + 2px)",
                          overflowY: "visible",
                        }),
                        control: (provider) => ({
                          ...provider,
                          borderColor: touched.city
                            ? !errors.city
                              ? "#34c38f"
                              : "#f46a6a"
                            : "#ced4da",
                        }),
                        placeholder: (provider) => ({
                          ...provider,
                          color: "#a0b0ca",
                        }),
                      }}
                      value={
                        formik.values.city
                          ? {
                              label: formik.values.city,
                              value: formik.values.city,
                            }
                          : null
                      }
                      onChange={(e) => setFieldValue("city", e.value)}
                      options={helperFunction.convertToSelectList(
                        cities,
                        "name",
                        "name"
                      )}
                    />
                    {touched.city && errors.city && (
                      <div className="text-danger">{errors.city}</div>
                    )}
                  </div>
                </div>
                {/* Postal Code */}
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Postal Code</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="text"
                      className={
                        "form-control" +
                        (touched.postal_code
                          ? !errors.postal_code
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...getFieldProps("postal_code")}
                      placeholder="Enter Postal Code"
                    />
                    {touched.postal_code && errors.postal_code && (
                      <div className="text-danger">{errors.postal_code}</div>
                    )}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Vat No</label>
                  </div>
                  <div className="col-9">
                    <input
                      required={false}
                      type="text"
                      className={
                        "form-control" +
                        (formik.touched.vat_no
                          ? !formik.errors.vat_no
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("vat_no")}
                      placeholder="Enter Vat Number"
                      minLength="10"
                    />
                    {formik.touched.vat_no && formik.errors.vat_no ? (
                      <div className="text-danger">{formik.errors.vat_no}</div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Contact No.</label>
                  </div>
                  <div className="col-9">
                    <div
                      className={
                        formik.touched.vendor_contact_number
                          ? !formik.errors.vendor_contact_number
                            ? " contact-success"
                            : " contact-error"
                          : ""
                      }
                    >
                      <PhoneCode
                        Addphone={(value) =>
                          formik.setValues({
                            ...formik.values,
                            vendor_contact_number: value,
                          })
                        }
                        phone={formik.values.vendor_contact_number}
                      />
                    </div>
                    {formik.touched.vendor_contact_number &&
                    formik.errors.vendor_contact_number ? (
                      <div className="text-danger">
                        {formik.errors.vendor_contact_number}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="mb-3 row">
                  <div className="col-3">
                    <label className="form-label">Email ID</label>
                  </div>
                  <div className="col-9">
                    <input
                      type="email"
                      className={
                        "form-control" +
                        (formik.touched.vendor_email
                          ? !formik.errors.vendor_email
                            ? " is-valid"
                            : " is-invalid"
                          : "")
                      }
                      {...formik.getFieldProps("vendor_email")}
                      placeholder="Enter Email"
                    />
                    {formik.touched.vendor_email &&
                    formik.errors.vendor_email ? (
                      <div className="text-danger">
                        {formik.errors.vendor_email}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-3 d-flex justify-content-between">
                <button
                  className="btn btn-danger w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => history.goBack()}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  type="button"
                  onClick={() => formik.handleSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};
